import { render } from "./BlStandaloneSortable.vue?vue&type=template&id=e3a352a8"
import script from "./BlStandaloneSortable.vue?vue&type=script&lang=js"
export * from "./BlStandaloneSortable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__